import type { ReactNode } from "react";
import { useTranslation as useI18nextTranslation } from "react-i18next";
import { i18n } from "./i18n";

export const localization = i18n;

export const changeLanguage = (lang: string, callback?: () => void) => {
  void i18n.changeLanguage(lang).then(() => callback?.());
};

export const t = i18n.t.bind(i18n);

export const useTranslation = useI18nextTranslation;

export const LocalizationProvider = ({ children }: { children: ReactNode; i18n?: unknown }) => children;
